import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../../../../../../../../_metronic/helpers'

const EnterprisesListLoading = () => {
  const intl = useIntl()
  const styles = {
    borderRadius: '0.475rem',
    boxShadow: '0 0 50px 0 rgb(82 63 105 / 15%)',
    backgroundColor: '#fff',
    color: '#7e8299',
    fontWeight: '500',
    margin: '0',
    width: '50',
    padding: '1rem 2rem',
    top: 'calc(50% - 2rem)',
    left: 'calc(40% - 4rem)',
  }

  return (
    <div style={{...styles, position: 'absolute', textAlign: 'center'}}>
      {/* {intl.formatMessage({id: 'AUTH.PLEASEWAIT'})} */}
      <img
        className='ml--5'
        width='30%'
        height='30%'
        alt='Orbit'
        // src={toAbsoluteUrl('/media/logos/loading1.gif')}
        src={toAbsoluteUrl('/media/logos/globo.gif')}
      />
      <br />
      <span>{intl.formatMessage({id: 'AUTH.PLEASEWAIT'})}</span>
    </div>
  )
}

export {EnterprisesListLoading}
